/**
 * Status.jsx - System status page
 *
 * Checks backend health and displays service status
 */
import { useState, useEffect } from 'react';

const StatusDot = ({ status }) => {
  const getStatusClass = () => {
    switch (status) {
      case 'healthy':
        return 'status-dot status-dot-healthy';
      case 'unhealthy':
        return 'status-dot status-dot-unhealthy';
      default:
        return 'status-dot status-dot-checking';
    }
  };

  return <span className={getStatusClass()}></span>;
};

const StatusRow = ({ name, status }) => (
  <div className="status-row">
    <StatusDot status={status} />
    <span className="status-name">{name}</span>
  </div>
);

const Status = () => {
  const [backendStatus, setBackendStatus] = useState('checking');
  const [services, setServices] = useState([]);

  useEffect(() => {
    const checkHealth = async () => {
      try {
        const backendUrl = process.env.REACT_APP_BACKEND_URL || '';
        const response = await fetch(`${backendUrl}/health`);

        if (!response.ok) {
          throw new Error('Backend unhealthy');
        }

        const data = await response.json();

        setBackendStatus('healthy');

        // Parse services from health response
        if (data.services) {
          const serviceList = Object.entries(data.services).map(([name, info]) => ({
            name,
            status: info.healthy ? 'healthy' : 'unhealthy',
          }));
          setServices(serviceList);
        }
      } catch (err) {
        console.error('[Status] Health check failed:', err);
        setBackendStatus('unhealthy');
        setServices([]);
      }
    };

    checkHealth();

    // Refresh every 30 seconds
    const interval = setInterval(checkHealth, 30000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="error-boundary">
      <div className="error-boundary-content">
        <div className="error-brand">Ramp.ai</div>

        <div className="error-divider"></div>

        <div className="status-list">
          <StatusRow name="Payment Service" status={backendStatus} />
          {services.map((service) => (
            <StatusRow key={service.name} name={service.name} status={service.status} />
          ))}
        </div>

        <div className="error-divider"></div>

        <p className="error-footer-help">
          Having trouble? <a href="mailto:support@rampwithai.com">Contact support</a>
        </p>
      </div>
    </div>
  );
};

export default Status;
